<template>
  <PreviewFrame :accent="slide.accent">
    <template #presenter>
      <div class="sw-stage">
        <div class="sw-wheel">
          <svg viewBox="0 0 100 100" class="sw-svg">
            <g class="sw-spin">
              <path d="M50,50 L50,2 A48,48 0 0,1 91.6,26 Z" :fill="seg(0)" />
              <path d="M50,50 L91.6,26 A48,48 0 0,1 91.6,74 Z" :fill="seg(1)" />
              <path d="M50,50 L91.6,74 A48,48 0 0,1 50,98 Z" :fill="seg(2)" />
              <path d="M50,50 L50,98 A48,48 0 0,1 8.4,74 Z" :fill="seg(3)" />
              <path d="M50,50 L8.4,74 A48,48 0 0,1 8.4,26 Z" :fill="seg(4)" />
              <path d="M50,50 L8.4,26 A48,48 0 0,1 50,2 Z" :fill="seg(5)" />
            </g>
            <circle
              cx="50"
              cy="50"
              r="6"
              fill="white"
            />
          </svg>
          <span class="sw-pointer"></span>
        </div>
        <div class="sw-label">
          <span class="sw-label-cap">Selected</span>
          <span class="sw-label-name">Maya</span>
        </div>
      </div>
    </template>

    <template #audience>
      <span class="sw-phone-q"></span>
      <div class="sw-phone-screen">
        <span class="material-symbols-rounded sw-phone-icon">casino</span>
        <span class="sw-phone-text">Watch the wheel!</span>
      </div>
      <button type="button" class="sw-phone-btn" tabindex="-1">
        Spin again
      </button>
    </template>
  </PreviewFrame>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue'
import type { SlideType } from '../../data/slideTypeCatalog'
import PreviewFrame from './PreviewFrame.vue'

export default Vue.extend({
  name: 'PreviewSpinnerWheel',
  components: { PreviewFrame },
  props: {
    slide: { type: Object as PropType<SlideType>, required: true },
  },
  methods: {
    seg(i: number): string {
      const fills = [
        'var(--accent)',
        'rgba(15, 15, 20, 0.08)',
        'color-mix(in srgb, var(--accent) 60%, white)',
        'rgba(15, 15, 20, 0.18)',
        'color-mix(in srgb, var(--accent) 35%, white)',
        'rgba(15, 15, 20, 0.05)',
      ]
      return fills[i] || 'rgba(15,15,20,0.1)'
    },
  },
})
</script>

<style scoped lang="scss">
.sw-stage {
  flex: 1;
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: center;
  gap: 16px;
}
.sw-wheel {
  position: relative;
  width: 140px; height: 140px;
  margin: 0 auto;
}
.sw-svg {
  width: 100%; height: 100%;
  transform-origin: 50% 50%;
}
.sw-spin {
  transform-origin: 50% 50%;
  animation: sw-rotate 4s cubic-bezier(0.18, 0.9, 0.3, 1) infinite;
}
.sw-pointer {
  position: absolute;
  top: -4px; left: 50%; transform: translateX(-50%);
  width: 0; height: 0;
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  border-top: 12px solid rgba(15, 15, 20, 0.85);
}
.sw-label {
  display: flex; flex-direction: column; gap: 4px;
}
.sw-label-cap {
  font-size: 9px; font-weight: 700;
  letter-spacing: 0.08em; text-transform: uppercase;
  color: rgba(15, 15, 20, 0.45);
}
.sw-label-name {
  font-size: 22px; font-weight: 800;
  color: var(--accent);
  animation: sw-flash 4s ease-out infinite;
}

/* ---- Audience phone ---- */
.sw-phone-q {
  display: block; height: 8px; border-radius: 999px;
  width: 70%; background: rgba(15, 15, 20, 0.18);
  margin-bottom: 4px;
}
.sw-phone-screen {
  background: color-mix(in srgb, var(--accent) 8%, white);
  border-radius: 10px;
  padding: 16px 8px;
  display: flex; flex-direction: column; align-items: center; gap: 6px;
}
.sw-phone-icon {
  font-size: 32px; color: var(--accent);
  animation: sw-tilt 4s ease-in-out infinite;
}
.sw-phone-text {
  font-size: 11px; font-weight: 700;
  color: rgba(15, 15, 20, 0.7);
}
.sw-phone-btn {
  appearance: none; border: 1px solid color-mix(in srgb, var(--accent) 30%, transparent);
  background: white; color: var(--accent);
  font-family: inherit; font-weight: 700; font-size: 11px;
  padding: 8px; border-radius: 8px; cursor: pointer;
}

@keyframes sw-rotate {
  0%   { transform: rotate(0deg); }
  60%  { transform: rotate(720deg); }
  85%, 100% { transform: rotate(745deg); }
}
@keyframes sw-flash {
  0%, 75% { opacity: 0.3; transform: scale(0.95); }
  85%     { opacity: 1; transform: scale(1.05); }
  100%    { opacity: 1; transform: scale(1); }
}
@keyframes sw-tilt {
  0%, 100% { transform: rotate(-8deg); }
  50%      { transform: rotate(8deg); }
}

@media (prefers-reduced-motion: reduce) {
  .sw-spin, .sw-label-name, .sw-phone-icon { animation: none; }
}
</style>
